module.exports = __webpack_public_path__ + "img/23.5cf916e3.jpg";